import { Box } from '@stockx/ui';
import { useTranslation } from 'react-i18next';

import ContentWrapper from '@app/shell/SiteHeader/Header/components/Content/components/ContentWrapper';
import { NavBarInner } from '@app/shell/SiteHeader/shared/components/Header.styles';
import { Wordmark } from '@stockx/icons';
import React from 'react';

const Auth = () => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <NavBarInner className="social-confirm" data-component="NavBarInner">
        <Box className="navbar-brand logo dark">
          <Wordmark title={t('stockx_logo')} />
        </Box>
      </NavBarInner>
    </ContentWrapper>
  );
};

export default Auth;
